import styled from 'styled-components';

import * as theme from '../../../theme';

export const Action = styled.div`
  display: flex;
  align-items: center;
  color: ${({isDeleted}) => (isDeleted ? theme.statusColors.error : theme.statusColors.success)};
`;
